import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../App';

function Support() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'general',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Netlify Forms will handle this
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setFormData({ name: '', email: '', subject: 'general', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="page-content">
      <Helmet>
        <title>Chefyz - {t.support.title}</title>
        <meta name="description" content={t.support.subtitle} />
        <meta property="og:title" content={`Chefyz - ${t.support.title}`} />
        <meta property="og:description" content={t.support.subtitle} />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1>{t.support.title}</h1>
          <p>{t.support.subtitle}</p>
        </div>
      </div>

      <div className="page-body">
        <div className="container">
          <div className="support-content">
            {/* FAQ Section */}
            <div className="faq-section">
              <div className="section-header">
                <h2>{t.support.faq.title}</h2>
              </div>
              <div className="faq-grid">
                <div className="faq-item">
                  <h3>{t.support.faq.q1}</h3>
                  <p>{t.support.faq.a1}</p>
                </div>
                <div className="faq-item">
                  <h3>{t.support.faq.q2}</h3>
                  <p>{t.support.faq.a2}</p>
                </div>
                <div className="faq-item">
                  <h3>{t.support.faq.q3}</h3>
                  <p>{t.support.faq.a3}</p>
                </div>
                <div className="faq-item">
                  <h3>{t.support.faq.q4}</h3>
                  <p>{t.support.faq.a4}</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-section">
              <h2>{t.support.contact.title}</h2>

              {submitted && (
                <div className="form-success">
                  ✅ {t.support.contact.success}
                </div>
              )}

              <form
                className="contact-form"
                name="contact"
                method="POST"
                data-netlify="true"
                netlify-honeypot="bot-field"
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="form-name" value="contact" />
                <p style={{ display: 'none' }}>
                  <label>Don't fill this out: <input name="bot-field" /></label>
                </p>

                <div className="form-group">
                  <label>{t.support.contact.name}</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    data-testid="contact-name"
                  />
                </div>

                <div className="form-group">
                  <label>{t.support.contact.email}</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    data-testid="contact-email"
                  />
                </div>

                <div className="form-group">
                  <label>{t.support.contact.subject}</label>
                  <select
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    data-testid="contact-subject"
                  >
                    <option value="general">{t.support.contact.subjects.general}</option>
                    <option value="bug">{t.support.contact.subjects.bug}</option>
                    <option value="feature">{t.support.contact.subjects.feature}</option>
                    <option value="account">{t.support.contact.subjects.account}</option>
                    <option value="other">{t.support.contact.subjects.other}</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>{t.support.contact.message}</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    data-testid="contact-message"
                  ></textarea>
                </div>

                <div className="form-submit">
                  <button type="submit" className="btn btn-primary" data-testid="contact-submit">
                    📨 {t.support.contact.send}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
